import _ from 'lodash';

export const toolkitMixin = {
  computed: {
    getItem() {
      return _.cloneDeep(this.$store.getters['toolkit/getItemData']);
    },
  },
  methods: {
    setItem(item) {
      return this.$store.dispatch('toolkit/updateItemKey', { data: item });
    },
  },
};

export default toolkitMixin;
